
const focusSearch = ():void => {
  const elems = document.querySelectorAll('[data-focus-search]')
  
  elems.forEach(elem => {
    elem.addEventListener('click', () => {
      const searchToggle: HTMLElement = document.querySelector('[data-search-toggle]')
      searchToggle.click()
      searchToggle.focus()
    })
  });
}

export default focusSearch;